const councilDetail = {
  en: {
    councilDetailPage: {
      statuses: {
        certified: "certified", approved: "approved", pending: "pending", rejected: "rejected"
      },
      notFound: "Council Not Found",
      backToCouncils: "Back to Councils",
      councilorSeats: "{{count}} councilor seats",
      winningParty: "Winning Party",
      mayor: "Mayor: {{name}}",
      tabs: { results: "Results", validation: "Validation", candidates: "Candidates", history: "History" },
      results: {
        noneTitle: "No Results Yet",
        noneText: "Results for this council have not been submitted",
        voteStatistics: "Vote Statistics",
        registeredVoters: "Registered Voters",
        totalVotesCast: "Total Votes Cast",
        validVotes: "Valid Votes",
        rejectedVotes: "Rejected Votes",
        turnout: "Turnout",
        partyBreakdown: "Party Vote Breakdown",
        votesTooltip: "{{votes}} votes ({{percentage}}%)",
        noPartyData: "No party data available"
      },
      validation: {
        title: "Results Validation Path",
        description: "Track the credibility and validation status of election results",
        noResults: "No results to validate",
        credibilityScore: "Credibility Score",
        stepProgress: "Step {{current}} of {{total}} completed",
        completed: "Completed",
        pending: "Pending",
        verified: "Verified"
      },
      candidates: {
        title: "Mayor Aspirants",
        description: "Candidates running for mayor in this council",
        none: "No candidates registered for this council"
      },
      history: {
        title: "Historical Results",
        description: "Compare results across different election periods",
        winner: "Winner:",
        votesCast: "Votes Cast:",
        validVotes: "Valid Votes:",
        na: "N/A",
        none: "No historical results available"
      }
    }
  },
  fr: {
    councilDetailPage: {
      statuses: {
        certified: "certifié", approved: "approuvé", pending: "en attente", rejected: "rejeté"
      },
      notFound: "Commune introuvable",
      backToCouncils: "Retour aux communes",
      councilorSeats: "{{count}} sièges de conseiller municipal",
      winningParty: "Parti vainqueur",
      mayor: "Maire : {{name}}",
      tabs: { results: "Résultats", validation: "Validation", candidates: "Candidats", history: "Historique" },
      results: {
        noneTitle: "Aucun résultat pour le moment",
        noneText: "Les résultats de cette commune n'ont pas encore été soumis",
        voteStatistics: "Statistiques du vote",
        registeredVoters: "Électeurs inscrits",
        totalVotesCast: "Total des votes exprimés",
        validVotes: "Votes valides",
        rejectedVotes: "Votes rejetés",
        turnout: "Taux de participation",
        partyBreakdown: "Répartition des voix par parti",
        votesTooltip: "{{votes}} voix ({{percentage}} %)",
        noPartyData: "Aucune donnée de parti disponible"
      },
      validation: {
        title: "Parcours de validation des résultats",
        description: "Suivez la crédibilité et l'état de validation des résultats électoraux",
        noResults: "Aucun résultat à valider",
        credibilityScore: "Score de crédibilité",
        stepProgress: "Étape {{current}} sur {{total}} terminée",
        completed: "Terminée",
        pending: "En attente",
        verified: "Vérifié"
      },
      candidates: {
        title: "Aspirants à la mairie",
        description: "Candidats à la mairie dans cette commune",
        none: "Aucun candidat enregistré pour cette commune"
      },
      history: {
        title: "Résultats historiques",
        description: "Comparez les résultats entre différentes périodes électorales",
        winner: "Vainqueur :",
        votesCast: "Votes exprimés :",
        validVotes: "Votes valides :",
        na: "N/D",
        none: "Aucun résultat historique disponible"
      }
    }
  }
};

export default councilDetail;
